import { IconFileZip, IconCalendar, IconWeight, IconCloudDownload } from "@tabler/icons-react";
import { Button } from "../../components";
import { formatDateTime, formatFileSize } from "../../../utils";
import type { ZipStatusDoc } from "../Download";
import "./ZipFile.scss";
import { useTranslation } from "react-i18next";

export interface ZipFileProps {
  status: ZipStatusDoc;
}

export const ZipFile = ({ status }: ZipFileProps) => {
  const { t } = useTranslation();

  const fileName = status.fileName ?? "—";
  const sizeBytes = status.sizeBytes ?? 0;
  const dateCreated = status.dateCreated;

  const handleDownload = () => {
    if (!status.downloadUrl) return;
    const a = document.createElement("a");
    a.href = status.downloadUrl;
    if (status.fileName) a.download = status.fileName;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div className="zip-file">
      <div className="zip-file-main">
        <div className="zip-file-icon">
          <IconFileZip />
        </div>
        <div className="zip-file-info">
          <div className="zip-file-name">{fileName}</div>
          <div className="zip-file-meta">
            <span className="meta-item">
              <IconWeight />
              {formatFileSize(sizeBytes)}
            </span>
            <span className="meta-item">
              <IconCalendar />
              {formatDateTime(dateCreated)}
            </span>
          </div>
        </div>
      </div>

      {status.downloadUrl && (
        <div className="zip-file-actions">
          <Button icon={<IconCloudDownload />} onClick={handleDownload}>
            {t("download.downloadBtn")}
          </Button>
        </div>
      )}
    </div>
  );
};
